import { FC } from 'react';
import { ConfidentialUsersTabProps } from './ConfidentialUsersTabProps';
import ProjectResponsibleForm from './ProjectResponsibleForm';
import { defaultProjectResponsibleFields } from './utils';

const ConfidentialUsersTab: FC<ConfidentialUsersTabProps> = ({ usersList }) => {
  return (
    <>
      <ProjectResponsibleForm
        fields={defaultProjectResponsibleFields}
        usersList={usersList}
      />
    </>
  );
};

export default ConfidentialUsersTab;
